__webpack_require__.p = "/educate/";